import * as yup from 'yup'

const validationSchema = yup.object({
  currentPassword: yup
    .string()
    .min(6, 'Use 6 characters or more for your password')
    .max(20, 'Enter a password less than 20 characters long')
    // .matches(
    //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
    //   'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
    // )
    .required('This field is required'),
  newPassword: yup
    .string()
    .min(6, 'Use 6 characters or more for your password')
    .max(20, 'Enter a password less than 20 characters long')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      'Enter a password containing 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
    )
    .required('This field is required'),

  repeatPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .required('This field is required')
})
export default validationSchema
